var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWeatherWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.253 8.703c0-1.757 1.44-3.181 3.216-3.181 1.777 0 3.217 1.424 3.217 3.181 0 1.757-1.44 3.181-3.217 3.181H3.696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.474 3c1.777 0 3.217 1.424 3.217 3.181 0 1.757-1.44 3.181-3.217 3.181H6.096m6.541 11.407c1.777 0 3.216-1.425 3.216-3.182 0-1.756-1.44-3.18-3.216-3.18H1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.348 17.587a.103.103 0 01-.103.103.103.103 0 01-.104-.103.104.104 0 01.207 0zm6.08-8.875a.103.103 0 01-.103.102.103.103 0 01-.103-.102.103.103 0 11.206 0zM8.913 5.977a.103.103 0 01-.103.102.103.103 0 01-.104-.102c0-.057.046-.103.104-.103.057 0 .103.046.103.103z"
  }))));
}

export default SvgIconWeatherWind;